var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.75C10.6875 16.75 11.2762 16.505 11.7663 16.015C12.2554 15.5258 12.5 14.9375 12.5 14.25C12.5 13.5625 12.2554 12.9738 11.7663 12.4837C11.2762 11.9946 10.6875 11.75 10 11.75C9.3125 11.75 8.72417 11.9946 8.235 12.4837C7.745 12.9738 7.5 13.5625 7.5 14.25C7.5 14.9375 7.745 15.5258 8.235 16.015C8.72417 16.505 9.3125 16.75 10 16.75ZM2.5 25.5C1.8125 25.5 1.22417 25.2554 0.735 24.7663C0.245 24.2763 0 23.6875 0 23V3C0 2.3125 0.245 1.72375 0.735 1.23375C1.22417 0.744583 1.8125 0.5 2.5 0.5H13.75L20 8V22.4688L14.2812 16.75C14.5104 16.3958 14.6875 16.0104 14.8125 15.5938C14.9375 15.1771 15 14.7292 15 14.25C15 12.875 14.5104 11.6979 13.5312 10.7188C12.5521 9.73958 11.375 9.25 10 9.25C8.625 9.25 7.44792 9.73958 6.46875 10.7188C5.48958 11.6979 5 12.875 5 14.25C5 15.625 5.48958 16.8021 6.46875 17.7812C7.44792 18.7604 8.625 19.25 10 19.25C10.4792 19.25 10.9325 19.1875 11.36 19.0625C11.7867 18.9375 12.1771 18.7604 12.5312 18.5312L19 25C18.8125 25.1667 18.5729 25.2917 18.2812 25.375C17.9896 25.4583 17.7292 25.5 17.5 25.5H2.5Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspections);
export default __webpack_public_path__ + "static/media/inspections.fb49fa113e3aead9c9e6445a6982b957.svg";
export { ForwardRef as ReactComponent };